import type { TextFieldProps } from '@mui/material';
import { InputAdornment, TextField } from '@mui/material';
import { blueGrey } from '@mui/material/colors';
import React from 'react';
import { SearchIcon } from '../../../../icons';

type SearchInputProps = TextFieldProps & {
  showLabel?: boolean;
};

export const SearchInput: React.FC<SearchInputProps> = ({ showLabel = true, ...props }) => {
  return (
    <TextField
      size="medium"
      label={showLabel ? 'Search' : undefined}
      placeholder="Name, email, etc..."
      {...props}
      sx={{
        width: '300px',
        ...props.sx,
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color={blueGrey[400]}/>
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
    />
  );
};